import { CardContent, Stack, Typography as T } from "@mui/material";
import { SiteDetails } from "catalog/types/interfaces/conceptResponse";
import pluralize from "pluralize";
import { CohortFilledIcon, CohortIcon } from "~/assets/icons";
import FlatCard from "~/components/FlatCard";
import useUser from "~/contexts/user";

const numFormatter = new Intl.NumberFormat("en");

const ConceptTitleCard = ({ data }: { data: SiteDetails }) => {
  const user = useUser();
  const permissions = user?.permissions ?? [];

  return (
    <FlatCard>
      <CardContent
        sx={{
          alignItems: "center",
          gap: 2,
          paddingTop: 4,
        }}
      >
        <Stack gap={2} maxWidth={628}>
          <Stack alignItems="center" gap={1}>
            <CohortFilledIcon color="#B7B7C8" />
            {data && (
              <T variant="subtitle2">
                {numFormatter.format(data.participant_count ?? 0)}{" "}
                {pluralize("participant", data.participant_count)}
              </T>
            )}
          </Stack>
        </Stack>
      </CardContent>
    </FlatCard>
  );
};

export default ConceptTitleCard;
